/* eslint-disable no-unused-vars */
import { Container, Grid, Typography } from "@material-ui/core";
import { VisibilityOffOutlined, VisibilityOutlined } from "@material-ui/icons";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import axios from "axios";
import clsx from "clsx";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useHistory, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import globalColors from "../../../../_metronic/_assets/sass/custom/globalColors.scss";
import { ReactComponent as IconCircleRight } from "../../../assets/icons/icon_circle-chevron-right-fill.svg";
import { DatePicker } from "../../../components/InputDatePicker/CustomDatePicker";
import InputForm from "../../../components/InputForm";
import { UserRole } from "../../../enums/UserRole";
import { AppAPIService } from "../../../services/AppAPIService";
import IsValidEmail from "../../../utils/validators/IsValidEmail";
import {
  getPasswordRequirements,
  isPasswordValid,
  PASSWORD_MAX_LENGTH,
} from "../../../utils/validators/PasswordPolicy";
import Loading from "../../home/components/Loading";
import { StyledInput } from "../CreateNewPassword/styles";
import { useStyles } from "./style";

import FormatDocument from "../../../utils/FormatDocument";
import {
  handleInputCpf,
  handleInputEmail,
  handleInputName,
  handleInputPhone,
} from "./handlers";

const FinishRegstration = () => {
  const id = 1;
  const api = AppAPIService.getInstance();
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isValidToken, setIsValidToken] = useState(false);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const token = params.get("token");
  const history = useHistory();
  const [newPswVisibility, setNewPswVisibility] = useState(false);
  const [confirmPswVisibility, setConfirmPswVisibility] = useState(false);

  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [passwordRole, setPasswordRole] = useState("ok");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [confirmPasswordRole, setConfirmPasswordRole] = useState("ok");

  const classes = useStyles();

  const [cep, setCep] = useState("");
  const [cepError, setCepError] = useState("");
  const [routeAddress, setRouteAddress] = useState("");
  const [neighborhood, setNeighborhood] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [streetNumber, setStreetNumber] = useState("");
  const [complement, setComplement] = useState("");
  const [responsible, setResponsible] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [birthDateRole, setBirthDateRole] = useState("ok");

  /*name*/
  const [name, setName] = useState("");
  const [nameRole, setNameRole] = useState("ok");
  const [nameError, setNameError] = useState("");

  /*phone*/
  const [phone, setPhone] = useState("");
  const [phoneRole, setPhoneRole] = useState("ok");
  const [phoneError, setPhoneError] = useState("");

  const setFormattedCpfCnpj = (e) => {
    if (e.length === 14) {
      setCpfCnpj(
        e.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")
      );
    } else if (e.length === 11) {
      setCpfCnpj(e.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4"));
    } else {
      setCpfCnpj(e);
    }
  };

  /*cpfCnpj*/
  const [cpfCnpj, setCpfCnpj] = useState("");
  const [cpfCnpjRole, setCpfCnpjRole] = useState("ok");
  const [cpfCnpjError, setCpfCnpjError] = useState("");

  /* end cpfCnpj*/

  /*email*/
  const [email, setEmail] = useState("");
  const [emailRole, setEmailRole] = useState("ok");
  const [emailError, setEmailError] = useState("");

  /* end email*/
  /* profile */
  const [profilesOptions] = useState([
    { value: UserRole.ADMIN, label: "Administrador" },
    { value: UserRole.COLLABORATOR, label: "Colaborador" },
    { value: UserRole.CLIENT, label: "Cliente" },
  ]);
  const [profile, setProfile] = useState();
  const [profileRole, setProfileRole] = useState("ok");
  const [profileError, setProfileError] = useState("");

  const handleInputProfile = useCallback((e) => {
    if (!e) {
      setProfileError("Campo obrigatório");
      setProfileRole("notOk");
    } else {
      setProfile(e);
      setProfileError("");
      setProfileRole("ok");
    }
  }, []);
  /* end profile */

  const handleInputResponsible = (e) => {
    setResponsible(e);
  };
  // const isValidDate = (dateString) => {
  //   console.log("dateString", dateString);
  //   const value = dateString.replace(/\D/g, "");
  //   try {
  //     const day = value.substring(0, 2);
  //     const month = value.substring(2, 4);
  //     const year = value.substring(4, 8);
  //     const date = new Date(`${year}-${month}-${day}`);
  //     return date instanceof Date && !isNaN(date);
  //   } catch (error) {
  //     return false;
  //   }
  // }

  const handleInputBirthDate = useCallback((e) => {
    setBirthDate(e);
  }, []);

  //// callbacks

  const [cityOptions, setCityOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);

  const fetchCities = async (UF_ID) => {
    try {
      const response = await axios.get(
        `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${UF_ID}/municipios`
      );
      const citiesToOptions = response.data.map((cityData) => ({
        value: cityData.nome.toUpperCase(),
        label: cityData.nome.toUpperCase(),
      }));
      setCityOptions(citiesToOptions);
    } catch (error) {
      console.error("Erro ao buscar cidades:", error);
    }
  };
  const fetchStates = async () => {
    try {
      const response = await axios.get(
        "https://servicodados.ibge.gov.br/api/v1/localidades/estados"
      );
      const orderedStates = response.data.sort((a, b) => {
        if (a.nome > b.nome) {
          return 1;
        }
        if (a.nome < b.nome) {
          return -1;
        }
        return 0;
      });
      const statesToOptions = orderedStates.map((stateData) => ({
        value: stateData.nome.toUpperCase(),
        label: stateData.nome.toUpperCase(),
        sigla: stateData.sigla,
      }));
      setStateOptions(statesToOptions);
    } catch (error) {
      console.error("Erro ao buscar estados:", error);
    }
  };

  const handleInputState = useCallback((value) => {
    const selectedState = value;
    setState(selectedState);

    if (selectedState) {
      fetchCities(selectedState.sigla);
    } else {
      setCityOptions([]);
    }
  }, []);

  const handleInputCity = (value) => {
    const selectedCity = value;
    setCity(selectedCity);
  };

  useEffect(() => {
    fetchStates();
  }, []);

  const handleInputRouteAddress = useCallback((e) => {
    setRouteAddress(e);
  }, []);

  const handleInputStreetNumber = useCallback((e) => {
    setStreetNumber(e);
  }, []);

  const handleInputComplement = useCallback((e) => {
    setComplement(e);
  }, []);

  const handleInputNeighborhood = (e) => {
    setNeighborhood(e);
  };

  const handleInputPassword = (event) => {
    const value = event.target.value;
    setPassword(value);
    if (value.length < 1) {
      setPasswordError("Campo obrigatório");
      setPasswordRole("notOk");
    } else if (!isPasswordValid(value)) {
      setPasswordError("Confira abaixo os requisitos que ainda faltam.");
      setPasswordRole("notOk");
    } else {
      setPasswordError("");
      setPasswordRole("ok");
    }

    if (confirmPassword) {
      const passwordsMatch = value === confirmPassword;
      setConfirmPasswordError(
        passwordsMatch ? "" : "As senhas não coincidem"
      );
      setConfirmPasswordRole(passwordsMatch ? "ok" : "notOk");
    }
  };

  const handleInputConfirmPassword = (event) => {
    let value = event.target.value;
    setConfirmPassword(value);
    if (value.length < 1) {
      setConfirmPasswordError("Campo obrigatório");
      setConfirmPasswordRole("notOk");
    } else if (value !== password) {
      setConfirmPasswordError("As senhas não coincidem");
      setConfirmPasswordRole("notOk");
    } else {
      setConfirmPasswordError("");
      setConfirmPasswordRole("ok");
    }
  };
  const passwordRequirements = getPasswordRequirements(password);
  /* cep change */
  const handleInputCep = useCallback(
    async (value) => {
      setCep(value);

      if (value?.length === 8) {
        try {
          const response = await axios.get(
            `https://viacep.com.br/ws/${value}/json/`
          );
          const addressData = response.data;

          if (!addressData.erro) {
            const selectedState = stateOptions.find(
              (state) => state.sigla === addressData.uf
            );
            const addresDataCity = addressData?.localidade?.toUpperCase();
            if (selectedState) {
              handleInputNeighborhood(addressData?.bairro);
              handleInputRouteAddress(addressData?.logradouro);
              handleInputStreetNumber(addressData?.numero);
              handleInputComplement(addressData?.complemento);
              handleInputState(selectedState);
            }
            setCity({
              value: addresDataCity,
              label: addresDataCity,
            });
          }
        } catch (error) {
          console.error("Erro ao buscar informações do CEP:", error);
          setCepError("CEP não encontrado");
        }
      }
    },
    [
      stateOptions,
      handleInputState,
      handleInputRouteAddress,
      handleInputStreetNumber,
      handleInputComplement,
    ]
  );

  /* end cep change */
  /* clean form */
  const onCleanForm = async () => {
    setName("");
    setEmail("");
    setProfile("");
    setPhone("");
    setCpfCnpj("");
    setCep("");
    setRouteAddress("");
    setStreetNumber("");
    setComplement("");
    setNeighborhood("");
    setState("");
    setCity("");
    setPassword("");
    setConfirmPassword("");
    setResponsible("");
    setBirthDate("");
    setCepError("");
    setNameError("");
    setEmailError("");
    setProfileError("");
    setPhoneError("");
    setCpfCnpjError("");
  };

  /* form validation */
  const formIsValid = useCallback(() => {
    let validForm = true;
    validForm =
      name !== "" &&
      nameRole === "ok" &&
      email !== "" &&
      IsValidEmail(email) &&
      emailRole === "ok" &&
      profile !== "" &&
      profileRole === "ok" &&
      phone !== "" &&
      phoneRole === "ok" &&
      cpfCnpjRole === "ok" &&
      cpfCnpj !== "" &&
      password !== "" &&
      passwordRole === "ok" &&
      confirmPassword !== "" &&
      confirmPasswordRole === "ok" &&
      confirmPassword === password;
    return validForm;
  }, [
    name,
    nameRole,
    email,
    emailRole,
    profile,
    profileRole,
    phone,
    phoneRole,
    cpfCnpjRole,
    cpfCnpj,
    password,
    passwordRole,
    confirmPassword,
    confirmPasswordRole,
  ]);
  /* end form validation */
  /* submit */
  const submit = useCallback(
    async (e) => {
      setLoading(true);
      e.preventDefault();
      try {
        setLoading(true);
        await api.makeHttpRequest({
          url: `/user/registration-finish`,
          method: "PATCH",
          data: {
            // username: name,
            // email,
            // role: profile.value,
            phone: `${phone}`,
            cpfCnpj: `${cpfCnpj.replace(/[^0-9]/g, "")}`,
            responsible,
            birthDate: `${
              birthDate
                ? moment(birthDate, "YYYY-MM-DD").format("YYYY-MM-DD")
                : ""
            }`,
            postalCode: cep,
            routeAddress: `${routeAddress}`,
            neighborhood: `${neighborhood}`,
            streetNumber: `${streetNumber}`,
            complement: `${complement}`,
            city: city.value,
            state: state.value,
            token: token,
            password: password,
          },
        });
        setLoading(false);
        onCleanForm();
        Swal.fire({
          icon: "success",
          title: "Sucesso!",
          text: "Cadastro atualizado com sucesso!",
        }).then(() => {
          history.push("/auth/login");
        });
      } catch (error) {
        console.error("Erro ao atualizar usuário:", error);
        setLoading(false);
        let message = "";
        if (error?.response?.status === 409) {
          message = ", Usuário com esse email já cadastrado.";
        }
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Erro ao atualizar usuário " + message + ".",
        });
      } finally {
        setLoading(false);
      }
    },
    [
      history,
      api,
      phone,
      cpfCnpj,
      responsible,
      birthDate,
      cep,
      routeAddress,
      neighborhood,
      streetNumber,
      complement,
      city,
      state,
      token,
      password,
    ]
  );
  /* end submit */
  const setProfileComboValue = useCallback(
    (value) => {
      const option = profilesOptions.find((option) => option.value === value);
      handleInputProfile(option);
    },
    [handleInputProfile, profilesOptions]
  );

  const handleCheckInviteStatus = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await api.makeHttpRequest({
        url: "/user/validate-invite-token",
        method: "GET",
        params: {
          token: token,
        },
      });
      console.log("response", response);
      if (response.status === 200) {
        setIsValidToken(true);
        const user = response.user;
        setCpfCnpj(FormatDocument(user.cpfCnpj));
        setName(user.username);
        setEmail(user.email);
        setProfileComboValue(user.role);
      }
    } catch (error) {
      console.log("error", error);
      console.log("error.response", error.response);
      Swal.fire({
        title: "Erro!",
        text: "Token inválido!",
        icon: "error",
        confirmButtonText: "Ok",
      }).then(() => {});
    } finally {
      setIsLoading(false);
    }
  }, [api, token, setProfileComboValue]);

  React.useEffect(() => {
    handleCheckInviteStatus();
  }, [handleCheckInviteStatus]);
  return (
    <>
      <Loading isLoading={isLoading} />
      <Container
        maxWidth="lg"
        style={{
          padding: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {isLoading ? (
          <Loading />
        ) : (
          <>
            <Grid
              container
              md={12}
              sm={12}
              lg={10}
              className={clsx(classes.formComponent)}
              style={{
                display: "flex",
                flexDirection: "column",
                overflow: "visible",
                maxHeight: "none",
                marginTop: 0,
                marginBottom: 0,
              }}
            >
              <Container
                maxWidth={"lg"}
                style={{
                  padding: 0,
                  overflow: "visible",
                  margin: 0,
                  width: "100%",
                }}
              >
                <Typography
                  variant="h3"
                  className="xv-registration__title"
                  style={{
                    color: globalColors.primaryColor5,
                    fontSize: "24px",
                    fontWeight: "700",
                    margin: "0",
                    padding: "0 5px",
                  }}
                >
                  Complete seu cadastro
                </Typography>
                <Typography
                  variant="h3"
                  className="xv-registration__subtitle"
                  style={{
                    fontSize: "16px",
                    fontWeight: "400",
                    margin: "0",
                    marginTop: "16px",
                    fontFamily: "Open Sans",
                    fontStyle: "normal",
                    padding: "0 5px",
                    marginBottom: "10px",
                    color: globalColors.textColor2,
                  }}
                >
                  Preencha os campos abaixo para realizar o seu cadastro
                </Typography>
                {isValidToken ? (
                  <form
                    className={classes.form}
                    style={{
                      marginTop: "10px",
                    }}
                    autoComplete="off"
                  >
                    <Grid
                      Container
                      md={12}
                      sm={12}
                      lg={12}
                      className={clsx(classes.formInputs)}
                      maxWidth={"lg"}
                      style={{
                        padding: 0,
                        overflow: "visible",
                        margin: 0,
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                        justifyContent: "space-between",
                      }}
                    >
                      <Grid item xs={12} className="xv-registration__section-heading">
                        <span>01</span>
                        <div>
                          <strong>Dados pessoais</strong>
                          <small>Identificação e informações de contato</small>
                        </div>
                      </Grid>
                      <Grid item xs={12} md={4} sm={12} className={clsx(classes.formInputs)}>
                        <InputForm
                          type="text"
                          name="profile"
                          placeholder="Selecione o Perfil"
                          label={"Perfil *"}
                          isSelect={true}
                          options={profilesOptions}
                          value={profile}
                          onChange={handleInputProfile}
                          isDisabled={true}
                        />
                      </Grid>
                      <Grid item xs={12} md={4} sm={12} className={clsx(classes.formInputs)}>
                        <InputForm
                          type="text"
                          name="cpfCnpj"
                          placeholder="Digite CNPJ ou CPF"
                          label={"CNPJ/CPF *"}
                          value={cpfCnpj}
                          error={cpfCnpjError}
                          onChange={(e) =>
                            handleInputCpf({
                              setCpfCnpj,
                              setCpfCnpjError,
                              setCpfCnpjRole,
                              setFormattedCpfCnpj,
                              e,
                            })
                          }
                          role={cpfCnpjRole}
                          isDisabled
                        />
                      </Grid>
                      <Grid item xs={12} md={4} sm={12} className={clsx(classes.formInputs)}>
                        <InputForm
                          type="text"
                          isDisabled={true}
                          name="personType"
                          placeholder="Tipo de Pessoa"
                          label={"Tipo de Pessoa"}
                          value={
                            cpfCnpj.replace(/\D/g, "").length <= 11
                              ? "Pessoa Física"
                              : "Pessoa Jurídica"
                          }
                        />
                      </Grid>
                      <Grid item xs={12} md={6} sm={12} className={clsx(classes.formInputs)}>
                        <InputForm
                          type="text"
                          name="name"
                          placeholder="Digite a razão social ou nome completo"
                          label={"Razão Social/Nome *"}
                          value={name}
                          onChange={(e) =>
                            handleInputName({
                              setName,
                              setNameError,
                              setNameRole,
                              e,
                            })
                          }
                          error={nameError}
                          role={nameRole}
                          isDisabled={true}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} sm={12} className={clsx(classes.formInputs)}>
                        <InputForm
                          type="text"
                          name="responsible"
                          placeholder="Digite o nome do responsável"
                          label={"Responsável"}
                          value={responsible}
                          onChange={handleInputResponsible}
                        />
                      </Grid>
                      <Grid item xs={12} md={4} sm={12} className={clsx(classes.formInputs)}>
                        <InputForm
                          type="email"
                          name="email"
                          placeholder="Digite o e-mail"
                          label={"E-mail *"}
                          value={email}
                          error={emailError}
                          onChange={(e) =>
                            handleInputEmail({
                              setEmail,
                              setEmailError,
                              setEmailRole,
                              e,
                            })
                          }
                          isDisabled={true}
                        />
                      </Grid>
                      <Grid item xs={12} md={4} sm={12} className={clsx(classes.formInputs)}>
                        <InputForm
                          type="text"
                          name="phone"
                          placeholder="Digite o Telefone"
                          label={"Telefone/Celular *"}
                          value={phone}
                          error={phoneError}
                          onChange={(e) =>
                            handleInputPhone({
                              setPhone,
                              setPhoneError,
                              setPhoneRole,
                              e,
                            })
                          }
                          role={phoneRole}
                          required={true}
                        />
                      </Grid>
                      <Grid item xs={12} md={4} sm={12} className={clsx(classes.formInputs)}>
                        <InputForm
                          id="date"
                          type="date"
                          name="birthdate"
                          placeholder="Selecione a data"
                          label="Nascimento"
                          value={birthDate}
                          onChange={handleInputBirthDate}
                          role={birthDateRole}
                          InputLabelProps={{ shrink: true }}
                          className={clsx(classes.input)}
                        />
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {birthDateRole === "notOk" ? "Data inválida" : ""}
                        </span>
                      </Grid>
                      <Grid item xs={12} className="xv-registration__section-heading">
                        <span>02</span>
                        <div>
                          <strong>Endereço</strong>
                          <small>Localização principal para o cadastro</small>
                        </div>
                      </Grid>
                      <Grid item xs={12} md={4} sm={12} className={clsx(classes.formInputs)}>
                        <InputForm
                          type="text"
                          name="cep"
                          placeholder="Digite o CEP"
                          label="CEP"
                          value={cep}
                          error={cepError}
                          onChange={handleInputCep}
                        />
                      </Grid>
                      <Grid item xs={12} md={4} sm={12} className={clsx(classes.formInputs)}>
                        <InputForm
                          type="text"
                          name="estado"
                          placeholder="Selecione o Estado"
                          label="Estado"
                          isSelect={true}
                          options={stateOptions}
                          value={state}
                          onChange={handleInputState}
                        />
                      </Grid>
                      <Grid item xs={12} md={4} sm={12} className={clsx(classes.formInputs)}>
                        <InputForm
                          type="text"
                          name="cidade"
                          placeholder="Selecione a Cidade"
                          label="Cidade"
                          isSelect={true}
                          options={cityOptions}
                          value={city}
                          onChange={handleInputCity}
                        />
                      </Grid>
                      <Grid item xs={12} md={9} sm={12} className={clsx(classes.formInputs)}>
                        <InputForm
                          type="text"
                          name="endereco"
                          placeholder="Digite o logradouro (rua, avenida, praça etc)"
                          label="Endereço"
                          value={routeAddress}
                          onChange={handleInputRouteAddress}
                        />
                      </Grid>
                      <Grid item xs={12} md={3} sm={12} className={clsx(classes.formInputs)}>
                        <InputForm
                          type="text"
                          name="numero"
                          placeholder="Digite o número"
                          label="Número"
                          value={streetNumber}
                          onChange={handleInputStreetNumber}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} sm={12} className={clsx(classes.formInputs)}>
                        <InputForm
                          type="text"
                          name="complemento"
                          placeholder="Digite o complemento"
                          label="Complemento"
                          value={complement}
                          onChange={handleInputComplement}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} sm={12} className={clsx(classes.formInputs)}>
                        <InputForm
                          type="text"
                          name="bairro"
                          placeholder="Digite o bairro"
                          label="Bairro"
                          value={neighborhood}
                          onChange={handleInputNeighborhood}
                        />
                      </Grid>
                      <Grid
                        xs={12}
                        md={12}
                        sm={12}
                        className={clsx(classes.formInputs)}
                        style={{
                          paddingBottom: "10px",
                        }}
                      >
                        <div className="xv-registration__section-heading xv-registration__section-heading--password">
                          <span>03</span>
                          <div>
                            <strong>Acesso ao portal</strong>
                            <small>Defina uma senha segura para entrar na sua conta</small>
                          </div>
                        </div>
                        <StyledInput
                          key={newPswVisibility ? "password-visible" : "password-hidden"}
                          label="Senha"
                          placeholder="DIGITE SUA SENHA"
                          type={newPswVisibility ? "text" : "password"}
                          name="password"
                          required={true}
                          value={password}
                          error={passwordError}
                          onChange={handleInputPassword}
                          className={clsx(classes.passwordInput)}
                          variant="outlined"
                          inputProps={{
                            maxLength: PASSWORD_MAX_LENGTH,
                            autoComplete: "new-password",
                            style: {
                              textTransform: "none",
                              textAlign: "left",
                              direction: "ltr",
                              color: "var(--xv-foreground, #f5f0ee)",
                              WebkitTextFillColor: "var(--xv-foreground, #f5f0ee)",
                              caretColor: "var(--xv-foreground, #f5f0ee)",
                              opacity: 1,
                            },
                          }}
                          InputLabelProps={{ shrink: true }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="Alterar visibilidade da senha"
                                  onClick={() =>
                                    setNewPswVisibility(!newPswVisibility)
                                  }
                                  onMouseDown={(e) => e.preventDefault()}
                                  edge="end"
                                >
                                  {newPswVisibility ? (
                                    <VisibilityOffOutlined />
                                  ) : (
                                    <VisibilityOutlined />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />

                        <span style={{ color: "red", fontSize: "12px" }}>
                          {passwordError}
                        </span>
                        {password && (
                          <span
                            aria-live="polite"
                            style={{ color: globalColors.textColor2, fontSize: "12px" }}
                          >
                            {password.length} de {PASSWORD_MAX_LENGTH} caracteres digitados.
                          </span>
                        )}
                        <ul className={classes.passwordRequirements}>
                          <li data-valid={passwordRequirements.length}>
                            8 a {PASSWORD_MAX_LENGTH} caracteres
                          </li>
                          <li data-valid={passwordRequirements.uppercase}>
                            Uma letra maiúscula
                          </li>
                          <li data-valid={passwordRequirements.lowercase}>
                            Uma letra minúscula
                          </li>
                          <li data-valid={passwordRequirements.number}>
                            Um número
                          </li>
                          <li data-valid={passwordRequirements.special}>
                            Um caractere especial, como @, # ou !
                          </li>
                          <li data-valid={passwordRequirements.noWhitespace}>
                            Sem espaços
                          </li>
                        </ul>
                      </Grid>

                      <Grid
                        xs={12}
                        md={12}
                        sm={12}
                        className={clsx(classes.formInputs)}
                      >
                        <StyledInput
                          key={confirmPswVisibility ? "confirmation-visible" : "confirmation-hidden"}
                          label="Confirmar a senha"
                          placeholder="DIGITE NOVAMENTE A SUA SENHA"
                          type={confirmPswVisibility ? "text" : "password"}
                          required={true}
                          name="confirmPassword"
                          value={confirmPassword}
                          error={confirmPasswordError}
                          onChange={handleInputConfirmPassword}
                          className={clsx(classes.passwordInput)}
                          variant="outlined"
                          inputProps={{
                            maxLength: PASSWORD_MAX_LENGTH,
                            autoComplete: "new-password",
                            style: {
                              textTransform: "none",
                              textAlign: "left",
                              direction: "ltr",
                              color: "var(--xv-foreground, #f5f0ee)",
                              WebkitTextFillColor: "var(--xv-foreground, #f5f0ee)",
                              caretColor: "var(--xv-foreground, #f5f0ee)",
                              opacity: 1,
                            },
                          }}
                          InputLabelProps={{ shrink: true }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="Alterar visibilidade da confirmação da senha"
                                  onClick={() =>
                                    setConfirmPswVisibility(
                                      !confirmPswVisibility
                                    )
                                  }
                                  onMouseDown={(e) => e.preventDefault()}
                                  edge="end"
                                >
                                  {confirmPswVisibility ? (
                                    <VisibilityOffOutlined />
                                  ) : (
                                    <VisibilityOutlined />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {confirmPasswordError}
                        </span>
                        {confirmPassword && confirmPassword === password && (
                          <span
                            aria-live="polite"
                            style={{ color: "#257942", fontSize: "12px" }}
                          >
                            As senhas coincidem.
                          </span>
                        )}
                      </Grid>
                    </Grid>
                    <Container
                      maxWidth="xxl"
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        padding: "5px",
                        margin: 0,
                      }}
                    >
                      <Button
                        variant="primary"
                        type="submit"
                        color={globalColors.primaryColor2}
                        onClick={submit}
                        disabled={!formIsValid()}
                        title={
                          formIsValid ? "Salvar dados" : "Verifique os campos"
                        }
                        className={clsx(classes.submitButton)}
                      >
                        <b
                          className="text-light"
                          style={{
                            fontSize: "14px",
                          }}
                        >
                          SALVAR <IconCircleRight />
                        </b>
                      </Button>
                    </Container>
                  </form>
                ) : (
                  <>
                    <Container
                      maxWidth="xxl"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        padding: "5px",
                        margin: 0,
                        height: "100%",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        variant="h3"
                        style={{
                          textAlign: "center",
                          margin: "24px auto",
                        }}
                      >
                        Token inválido!
                      </Typography>
                      <Button
                        onClick={() => {
                          window.location.href = "/auth/login";
                        }}
                        variant="primary"
                        className={clsx(classes.submitButton)}
                        style={{
                          color: globalColors.colorWhite,
                          width: "fit-content",
                        }}
                      >
                        Clique aqui para ir para a página de login
                      </Button>
                    </Container>
                  </>
                )}
              </Container>
            </Grid>
          </>
        )}
      </Container>
    </>
  );
};

export default FinishRegstration;
